var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 912,
    height: 353,
    viewBox: "0 0 912 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M823.742 294.167H88.258C71.7831 294.167 58.8386 280.635 58.8386 264.75V88.2499C58.8386 71.7766 72.3715 58.8333 88.258 58.8333H823.742C840.217 58.8333 853.161 72.3649 853.161 88.2499V264.75C853.161 280.635 840.217 294.167 823.742 294.167Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M823.742 63.5399C837.275 63.5399 848.454 74.7182 848.454 88.2499V264.75C848.454 278.282 837.275 289.46 823.742 289.46H88.258C74.7251 289.46 63.5457 278.282 63.5457 264.75V88.2499C63.5457 74.7182 74.7251 63.5399 88.258 63.5399H823.742ZM823.742 58.8333H88.258C71.7831 58.8333 58.8386 72.3649 58.8386 88.2499V264.75C58.8386 281.223 72.3715 294.167 88.258 294.167H823.742C840.217 294.167 853.161 280.635 853.161 264.75V88.2499C853.161 72.3649 840.217 58.8333 823.742 58.8333Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M459.53 187.09C445.409 187.09 434.23 197.68 434.23 212.388C434.23 226.508 445.409 237.687 459.53 237.687C473.652 237.687 484.831 227.097 484.831 212.388C484.831 197.092 473.652 187.09 459.53 187.09ZM459.53 227.097C451.881 227.097 445.409 220.625 445.409 211.8C445.409 202.975 451.881 196.503 459.53 196.503C467.179 196.503 473.652 202.387 473.652 211.8C473.652 220.625 467.179 227.097 459.53 227.097ZM404.81 187.09C390.689 187.09 379.51 197.68 379.51 212.388C379.51 226.508 390.689 237.687 404.81 237.687C418.932 237.687 430.111 227.097 430.111 212.388C430.111 197.092 418.932 187.09 404.81 187.09ZM404.81 227.097C397.161 227.097 390.689 220.625 390.689 211.8C390.689 202.975 397.161 196.503 404.81 196.503C412.459 196.503 418.932 202.387 418.932 211.8C418.932 220.625 412.459 227.097 404.81 227.097ZM339.499 194.738V205.328H364.8C364.212 211.212 361.858 215.918 358.916 218.86C355.386 222.39 349.502 226.508 339.499 226.508C323.613 226.508 311.845 214.153 311.845 198.268C311.845 182.383 324.201 170.028 339.499 170.028C347.737 170.028 354.209 173.558 358.916 177.677L366.565 170.028C360.093 164.145 351.855 159.438 340.088 159.438C318.906 159.438 300.666 177.088 300.666 198.268C300.666 219.448 318.906 237.098 340.088 237.098C351.855 237.098 360.093 233.568 367.154 225.92C374.214 218.86 376.568 208.858 376.568 201.21C376.568 198.857 376.568 196.503 375.979 194.738H339.499ZM606.627 202.975C604.274 197.092 598.39 187.09 585.445 187.09C572.501 187.09 561.91 197.092 561.91 212.388C561.91 226.508 572.501 237.687 586.622 237.687C597.801 237.687 604.862 230.627 607.215 226.508L598.978 220.625C596.036 224.743 592.506 227.685 586.622 227.685C580.738 227.685 577.208 225.332 574.266 220.037L607.804 205.917L606.627 202.975ZM572.501 211.212C572.501 201.798 580.15 196.503 585.445 196.503C589.564 196.503 593.683 198.857 594.859 201.798L572.501 211.212ZM544.846 235.333H556.026V161.792H544.846V235.333ZM527.195 192.385C524.253 189.443 519.546 186.502 513.662 186.502C501.306 186.502 489.538 197.68 489.538 211.8C489.538 225.92 500.717 236.51 513.662 236.51C519.546 236.51 524.253 233.568 526.606 230.627H527.195V234.157C527.195 243.57 521.899 248.865 513.662 248.865C507.19 248.865 502.483 244.158 501.306 240.04L491.892 244.158C494.834 250.63 501.894 258.867 514.25 258.867C527.195 258.867 537.786 251.218 537.786 232.98V188.267H527.195V192.385ZM514.25 227.097C506.601 227.097 500.129 220.625 500.129 211.8C500.129 202.975 506.601 196.503 514.25 196.503C521.899 196.503 527.783 202.975 527.783 211.8C527.783 220.625 521.899 227.097 514.25 227.097ZM657.817 161.792H631.339V235.333H642.519V207.682H657.817C670.173 207.682 681.941 198.857 681.941 184.737C681.941 170.617 670.173 161.792 657.817 161.792ZM658.405 197.092H642.519V171.793H658.405C666.643 171.793 671.35 178.853 671.35 184.148C670.761 190.62 666.054 197.092 658.405 197.092ZM726.07 186.502C717.832 186.502 709.595 190.032 706.653 197.68L716.655 201.798C719.009 197.68 722.539 196.503 726.658 196.503C732.542 196.503 737.837 200.033 738.426 205.917V206.505C736.661 205.328 731.954 203.563 727.246 203.563C716.655 203.563 706.064 209.447 706.064 220.037C706.064 230.038 714.89 236.51 724.305 236.51C731.954 236.51 735.484 232.98 738.426 229.45H739.014V235.333H749.605V207.093C748.428 194.15 738.426 186.502 726.07 186.502ZM724.893 227.097C721.363 227.097 716.067 225.332 716.067 220.625C716.067 214.742 722.539 212.977 727.835 212.977C732.542 212.977 734.895 214.153 737.837 215.33C736.661 222.39 730.777 227.097 724.893 227.097ZM786.674 188.267L774.317 220.037H773.729L760.785 188.267H749.017L768.434 232.98L757.254 257.69H768.434L798.441 188.267H786.674ZM687.824 235.333H699.004V161.792H687.824V235.333Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.031 102.958C118.266 104.723 117.089 107.665 117.089 111.195V241.217C117.089 244.747 118.266 247.688 120.031 249.453L120.619 250.042L193.579 177.088V176.5V175.912L120.031 102.958Z",
    fill: "url(#paint0_linear_1276_889)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M217.703 201.798L193.579 177.677V176.5V175.912L217.703 151.79L218.292 152.378L247.123 168.852C255.36 173.558 255.36 181.207 247.123 185.913L217.703 201.798Z",
    fill: "url(#paint1_linear_1276_889)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M218.292 201.21L193.579 176.5L120.031 250.042C122.973 252.983 127.092 252.983 132.387 250.63L218.292 201.21Z",
    fill: "url(#paint2_linear_1276_889)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M218.292 151.79L132.387 102.958C127.092 100.017 122.973 100.605 120.031 103.547L193.579 176.5L218.292 151.79Z",
    fill: "url(#paint3_linear_1276_889)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M217.703 200.622L132.387 248.865C127.68 251.807 123.561 251.218 120.619 248.865L120.031 249.453L120.619 250.042C123.561 252.395 127.68 252.983 132.387 250.042L217.703 200.622Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M120.031 248.865C118.266 247.1 117.677 244.158 117.677 240.628V241.216C117.677 244.747 118.854 247.688 120.619 249.453V248.865H120.031Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M247.123 184.148L217.703 200.622L218.292 201.21L247.123 184.737C251.241 182.383 253.007 179.442 253.007 176.5C253.007 179.442 250.653 181.795 247.123 184.148Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M132.387 103.547L247.123 168.852C250.653 171.205 253.007 173.558 253.007 176.5C253.007 173.558 251.241 170.617 247.123 168.263L132.387 102.958C124.15 98.2516 117.677 102.37 117.677 111.783V112.372C117.677 102.958 124.15 98.84 132.387 103.547Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M315.964 135.317H311.257V104.135H301.254V100.017H325.378V104.135H315.375V135.317H315.964Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M351.855 104.135H335.969V115.313H350.679V119.432H335.969V130.61H351.855V135.317H331.262V100.017H351.855V104.135Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M358.916 135.317V100.017H363.623L375.979 121.785L388.335 100.017H393.042V135.317H388.335V114.137V108.253L377.156 127.668H374.214L363.035 108.253V114.137V135.317H358.916Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M413.636 135.905C409.517 135.905 406.575 134.728 404.222 131.787C401.868 129.433 400.692 125.903 400.692 121.785V100.017H405.399V122.373C405.399 125.315 405.987 127.668 407.752 129.433C408.929 131.198 411.283 131.787 414.225 131.787C417.166 131.787 418.932 131.198 420.697 129.433C421.874 127.668 423.05 125.315 423.05 122.373V100.017H427.757V122.373C427.757 126.492 426.581 130.022 424.227 132.375C420.697 134.728 417.166 135.905 413.636 135.905Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M460.119 100.017L447.174 115.313L461.296 135.317H456L444.232 118.843L438.937 125.315V135.317H434.23V100.017H438.937V118.255L454.235 100.017H460.119Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M462.472 135.317L476.005 100.017H481.301L494.833 135.317H489.538L486.008 125.903H470.71L467.179 135.317H462.472ZM472.475 121.785H484.243L478.359 105.9L472.475 121.785Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M499.541 135.317V100.017H504.836L521.899 127.668V120.608V100.017H526.606V135.317H521.899L503.659 106.488V113.548V135.317H499.541Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M546.612 135.317V100.017H557.202C562.498 100.017 567.205 101.782 570.147 104.723C573.677 108.253 574.854 112.372 574.854 117.667C574.854 122.962 573.089 127.08 570.147 130.61C566.617 134.14 562.498 135.317 557.202 135.317H546.612ZM550.73 131.198H557.202C561.321 131.198 564.263 130.022 566.617 127.668C568.97 125.315 570.147 121.785 570.147 117.667C570.147 113.548 568.97 110.018 566.617 107.665C564.263 105.312 560.733 104.135 557.202 104.135H550.73V131.198Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M581.326 135.317V100.017H586.033V135.317H581.326Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1276_889",
    x1: 187.105,
    y1: 110.075,
    x2: 88.369,
    y2: 208.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1276_889",
    x1: 257.916,
    y1: 176.508,
    x2: 115.545,
    y2: 176.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1276_889",
    x1: 204.918,
    y1: 190.009,
    x2: 71.023,
    y2: 323.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1276_889",
    x1: 101.775,
    y1: 59.8701,
    x2: 161.565,
    y2: 119.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/GooglePlay.7899e27a864c7a92edaa6aae3e4049a3.svg";
export { ForwardRef as ReactComponent };